import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { APIEndpoint, nonTokenRequireEndPt } from 'src/app/models/options/api-endpoint';
import { TokenAuthService } from 'src/app/helpers/token-auth.service';
import { TokenCookieService } from 'src/app/helpers/storage service/cookies/token-cookies.service';

@Injectable()
export class TokenInjectInterceptor implements HttpInterceptor {

  constructor(
    private tokenCookieSer: TokenCookieService
    //private tokenAuthService:TokenAuthService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const reg= new RegExp(nonTokenRequireEndPt.join('|'),'g')
    if(request.url.match(reg)===null){
      const tokenCookie = this.tokenCookieSer.getToken()
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenCookie}`
        }
      });
    }
    return next.handle(request);


    }
}
